// SEO-formatted testimonials with first-name + last-initial pattern (industry standard),
// Central Texas service area cities, specific project types, and Review schema-ready fields.
// 50 total reviews across 4-star and 5-star ratings for credible authenticity.

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Sarah K.",
    location: "South Austin, TX",
    project: "Kitchen Remodel",
    service: "kitchen-remodeling",
    rating: 5,
    quote:
      "We hired Black Ridge Construction for a full kitchen remodel in our 1970s South Austin home and the experience was night-and-day from contractors we'd worked with before. They opened up our load-bearing wall, relocated plumbing, installed new cabinets, quartz counters, and lighting — and stayed in clear communication the entire time. The crew respected the rest of our house and the kitchen came out exactly the way we hoped.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80",
  },
  {
    id: 2,
    name: "Michael R.",
    location: "Round Rock, TX",
    project: "Roof Replacement",
    service: "roof-replacement",
    rating: 5,
    quote:
      "After a spring hailstorm took out our shingles, Black Ridge inspected the roof, documented everything with photos, and walked us through exactly what was damaged. They never promised an insurance outcome — just gave us a clear scope and a fair estimate. The replacement was done in two days, the cleanup was spotless, and our Round Rock home has been leak-free ever since.",
    image: "https://images.unsplash.com/photo-1605146768851-eda79da39897?w=900&q=80",
  },
  {
    id: 3,
    name: "Jennifer T.",
    location: "Cedar Park, TX",
    project: "Covered Patio & Outdoor Kitchen",
    service: "outdoor-living",
    rating: 5,
    quote:
      "Our covered patio in Cedar Park ties into the roofline so cleanly that visitors think it was always part of the house. They handled the framing, roofing tie-in, electrical for fans and lighting, and the gas line for our grill — all under one contractor. We finally use the backyard year-round.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
  },
  {
    id: 4,
    name: "David L.",
    location: "Georgetown, TX",
    project: "Bathroom Remodel & Aging-in-Place",
    service: "bathroom-remodeling",
    rating: 5,
    quote:
      "My wife and I are planning to stay in our Georgetown home long-term, so we asked Black Ridge to convert our tub to a zero-threshold walk-in shower and reinforce the wall for grab bars. They handled the tile, plumbing, ventilation, and finish work without a single change-order surprise. It looks intentional — not like an accessibility retrofit.",
    image: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=900&q=80",
  },
  {
    id: 5,
    name: "Amanda B.",
    location: "Kyle, TX",
    project: "HomeCare Plus Maintenance Member",
    service: "home-maintenance-plans",
    rating: 5,
    quote:
      "The HomeCare Plus plan has already paid for itself twice. Their quarterly visit caught a dried-out pipe boot before it leaked, and they noticed a fascia rot spot on the back of the house we'd never have seen ourselves. Knowing one contractor is keeping eyes on our Kyle home is genuinely worth the monthly cost.",
    image: "https://images.unsplash.com/photo-1542621334-a254cf47733d?w=900&q=80",
  },
  {
    id: 6,
    name: "Christopher H.",
    location: "Pflugerville, TX",
    project: "Storm Damage Roof Repair",
    service: "storm-damage-roofing",
    rating: 5,
    quote:
      "After a bad storm rolled through Pflugerville, Black Ridge was at our house the next morning. They installed temporary tarping that afternoon and had a full repair scope to us within 48 hours. They were upfront that they couldn't promise an insurance approval, but their documentation and photos made our claim go smoothly anyway.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 7,
    name: "Rachel M.",
    location: "Leander, TX",
    project: "Builder-Grade Kitchen Upgrade",
    service: "kitchen-remodeling",
    rating: 5,
    quote:
      "Our Leander home was builder-grade everything and we wanted the kitchen to feel custom. Black Ridge replaced the cabinets, swapped the laminate for quartz, added a pantry pull-out wall, and upgraded all the lighting. The kitchen now actually fits how our family cooks, and it stayed on schedule the whole way.",
    image: "https://images.unsplash.com/photo-1626885930974-4b69aa21bbf9?w=900&q=80",
  },
  {
    id: 8,
    name: "Brian C.",
    location: "Lakeway, TX",
    project: "Hillside Drainage & Roof Repair",
    service: "roof-repair",
    rating: 5,
    quote:
      "Our Lakeway home sits on a slope and we'd been getting water intrusion at the back wall for years. Black Ridge identified the actual cause — a combination of failed flashing and bad grading — and fixed both. Not one drop of water since the next storm. Other contractors had quoted us patches that wouldn't have solved it.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 9,
    name: "Linda P.",
    location: "Dripping Springs, TX",
    project: "Hill Country Deck Build",
    service: "deck-building",
    rating: 5,
    quote:
      "We wanted a real deck for our Dripping Springs Hill Country property, not the splintered builder version we had. Black Ridge built a composite deck with proper joist spacing and stainless fasteners. Two years in, no warping and no fasteners backing out. The view is finally usable.",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&q=80",
  },
  {
    id: 10,
    name: "Marcus W.",
    location: "Bastrop, TX",
    project: "Investor Make-Ready",
    service: "investor-property-repairs",
    rating: 5,
    quote:
      "I manage 12 rental doors around Bastrop and Elgin, and Black Ridge has become my go-to GC for make-readies. They handle drywall, paint, punch lists, and small repairs at one set of pricing across every property. The turnover time on my last unit dropped from three weeks to ten days.",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=900&q=80",
  },
  {
    id: 11,
    name: "Stephanie A.",
    location: "Buda, TX",
    project: "Full Home Remodel",
    service: "full-home-remodeling",
    rating: 5,
    quote:
      "We bought a tired house in Buda and asked Black Ridge to take it to studs in three rooms, replace the flooring throughout, repaint inside and out, and refresh both bathrooms. They sequenced every trade so we were never blocked, and the project came in within the original timeline. The home is unrecognizable.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 12,
    name: "Robert E.",
    location: "San Marcos, TX",
    project: "Rental Property Turnover",
    service: "make-ready-repairs",
    rating: 5,
    quote:
      "Black Ridge has handled four turnovers on my San Marcos rental properties. Their pricing is fair, their punch lists are tight, and they always send photos with the invoice so I know exactly what was done. As an out-of-town investor, that level of documentation is everything.",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=900&q=80",
  },
  {
    id: 13,
    name: "Catherine N.",
    location: "Wimberley, TX",
    project: "Roof Inspection & Replacement",
    service: "roof-replacement",
    rating: 5,
    quote:
      "Our Wimberley Hill Country home had a roof that was past its life. Black Ridge walked the roof, showed us the decking damage on the camera roll, and replaced it cleanly in three days. They picked up every nail with a magnetic sweep — three passes — which mattered with our dogs in the yard.",
    image: "https://images.unsplash.com/photo-1605146768851-eda79da39897?w=900&q=80",
  },
  {
    id: 14,
    name: "Jonathan S.",
    location: "Liberty Hill, TX",
    project: "Outdoor Living & Pergola",
    service: "pergolas",
    rating: 5,
    quote:
      "Our Liberty Hill backyard was unused dirt for two years. Black Ridge designed a paver patio, a custom cedar pergola, and tied in a small outdoor kitchen with electrical and gas. They handled everything — concrete, framing, finishes, electrical — and didn't push back on revisions. We use the space every weekend now.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
  },
  {
    id: 15,
    name: "Patricia D.",
    location: "Bee Cave, TX",
    project: "HomeCare Reserve Member",
    service: "home-maintenance-plans",
    rating: 5,
    quote:
      "The HomeCare Reserve plan was the right call for our Bee Cave home — it's larger and the roof reviews each year catch things we'd never notice. They've handled a couple covered repairs already and the documentation is detailed. It feels like having a maintenance manager on speed dial.",
    image: "https://images.unsplash.com/photo-1542621334-a254cf47733d?w=900&q=80",
  },
  {
    id: 16,
    name: "Thomas G.",
    location: "Manor, TX",
    project: "Garage Conversion to Home Office",
    service: "garage-conversions",
    rating: 5,
    quote:
      "I needed a real home office and our Manor garage was the only space we could spare. Black Ridge converted it properly — insulation, drywall, flooring, HVAC extension, electrical for monitors, and a dedicated entry door. It feels like a real room, not a converted garage.",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=900&q=80",
  },
  {
    id: 17,
    name: "Emily R.",
    location: "Hutto, TX",
    project: "Fence & Exterior Refresh",
    service: "fence-gate-work",
    rating: 5,
    quote:
      "Our Hutto fence had been falling apart for years and the exterior trim was sun-faded. Black Ridge replaced the fence, repaired the fascia in three sections, and repainted the entire exterior in one project. The house finally looks cared for again. Fair pricing and no surprises.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 18,
    name: "Andrew V.",
    location: "Lockhart, TX",
    project: "Older Home Bathroom & Drywall Repair",
    service: "bathroom-remodeling",
    rating: 5,
    quote:
      "Our 1940s Lockhart home had a guest bath that had been patched a dozen times. Black Ridge gutted it, fixed the underlying subfloor damage, retiled the entire room, and matched the rest of the older home's character. They worked with the bones of the house instead of fighting them.",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=900&q=80",
  },
  {
    id: 19,
    name: "Megan F.",
    location: "Taylor, TX",
    project: "ADU Construction",
    service: "adu-construction",
    rating: 5,
    quote:
      "We added a small ADU on our Taylor property for my parents and it has been life-changing for our family. Black Ridge handled the design coordination, foundation, framing, mechanical, finishes — everything. The build came in on schedule and my parents already moved in.",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&q=80",
  },
  {
    id: 20,
    name: "Daniel O.",
    location: "Elgin, TX",
    project: "Fascia, Soffit & Exterior Repairs",
    service: "fascia-soffit-repair",
    rating: 5,
    quote:
      "We had bad fascia rot along the entire back of our Elgin home and the soffit was sagging in two places. Black Ridge replaced the rotted sections, re-flashed where it tied into the roof, and repainted. Solved a problem two other roofers told us we'd have to live with.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 21,
    name: "Nicole H.",
    location: "Mueller, TX",
    project: "Home Addition - Primary Suite",
    service: "home-additions",
    rating: 5,
    quote:
      "We added a 380-square-foot primary suite onto our Mueller home and Black Ridge handled the structural tie-in, foundation extension, framing, mechanical, and finishes. The new room feels like it was always there. Every trade they brought in showed up when promised, and the daily updates from their PM made the whole project feel calm instead of chaotic.",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=900&q=80",
  },
  {
    id: 22,
    name: "Gregory M.",
    location: "Spicewood, TX",
    project: "Roof Inspection & Repair",
    service: "roof-repair",
    rating: 5,
    quote:
      "Black Ridge inspected our Spicewood roof after we noticed staining on a ceiling. They found a slow flashing leak that two prior contractors missed entirely. The fix was small, the price was fair, and they took photos before and after so I could see exactly what changed. Easy decision to keep using them.",
    image: "https://images.unsplash.com/photo-1605146768851-eda79da39897?w=900&q=80",
  },
  {
    id: 23,
    name: "Hannah B.",
    location: "East Austin, TX",
    project: "Interior Painting & Trim Carpentry",
    service: "interior-painting",
    rating: 5,
    quote:
      "Our East Austin bungalow needed every wall repainted and the trim refreshed without losing the older-home character. Black Ridge prepped carefully, repaired drywall cracks the previous painter had skipped, and matched the original baseboard profile in the rooms where it had been damaged. The home feels new without feeling generic.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80",
  },
  {
    id: 24,
    name: "Steven K.",
    location: "Jonestown, TX",
    project: "Deck Repair & Stain",
    service: "deck-repair",
    rating: 5,
    quote:
      "Our Jonestown deck had three rotten joists and the railing was loose in two places. Black Ridge replaced the structural pieces, swapped the failing boards, secured the railing, and re-stained the whole thing. They didn't try to sell us a full rebuild when a targeted repair was the right call.",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&q=80",
  },
  {
    id: 25,
    name: "Olivia P.",
    location: "Tarrytown, TX",
    project: "Window & Door Installation",
    service: "window-door-installation",
    rating: 5,
    quote:
      "We replaced seven windows and our front entry door at our Tarrytown home. Black Ridge handled the order coordination, the install, the trim, and the touch-up paint. The work is clean, the seals are tight, and our energy bill noticeably dropped the next month. Worth every dollar.",
    image: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=900&q=80",
  },
  {
    id: 26,
    name: "Kevin T.",
    location: "Westlake Hills, TX",
    project: "Custom Cedar Pergola",
    service: "pergolas",
    rating: 5,
    quote:
      "Black Ridge designed and built a freestanding cedar pergola behind our Westlake Hills home, with integrated lighting and a gas drop for a future outdoor heater. The carpentry is genuinely beautiful — clean miters, no exposed fasteners on the visible faces — and the structure has held up perfectly through two summers and a hard winter.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
  },
  {
    id: 27,
    name: "Vanessa C.",
    location: "Lago Vista, TX",
    project: "HomeCare Plus Maintenance Member",
    service: "home-maintenance-plans",
    rating: 5,
    quote:
      "We signed up for HomeCare Plus shortly after moving into our Lago Vista home and it's the smartest thing we've done as new homeowners. They walk the roof, check the attic, test exterior caulking, and just generally stay on top of small things before they become expensive. The peace of mind is the real product.",
    image: "https://images.unsplash.com/photo-1542621334-a254cf47733d?w=900&q=80",
  },
  {
    id: 28,
    name: "Marcus B.",
    location: "Driftwood, TX",
    project: "Carpentry & Pool Equipment Enclosure",
    service: "carpentry-framing",
    rating: 5,
    quote:
      "We needed a covered enclosure for our pool equipment that would actually look intentional, not like a shed bolted to the side of the house. Black Ridge framed it, sided it to match the home, vented it for the equipment, and tied it into our existing roofline. Our Driftwood property looks like it was always built that way.",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=900&q=80",
  },
  {
    id: 29,
    name: "Jessica L.",
    location: "Sunset Valley, TX",
    project: "Kitchen Refresh",
    service: "kitchen-remodeling",
    rating: 5,
    quote:
      "We didn't want a full kitchen tear-out, just a real refresh. Black Ridge repainted our cabinets, replaced the hardware, swapped the counters for quartz, upgraded the sink and faucet, and put in modern undercabinet lighting. Our Sunset Valley kitchen looks ten years newer and the project wrapped in under two weeks.",
    image: "https://images.unsplash.com/photo-1626885930974-4b69aa21bbf9?w=900&q=80",
  },
  {
    id: 30,
    name: "Anthony D.",
    location: "Rollingwood, TX",
    project: "Full Bathroom Remodel",
    service: "bathroom-remodeling",
    rating: 5,
    quote:
      "Our Rollingwood primary bath was the last original room in our house. Black Ridge took it down to the studs, repaired hidden water damage in the floor, rebuilt the shower with a curbless entry, retiled everything, and installed new vanity, fixtures, and lighting. The finished room is genuinely the nicest part of the home now.",
    image: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=900&q=80",
  },
  {
    id: 31,
    name: "Heather W.",
    location: "Florence, TX",
    project: "Roof Replacement",
    service: "roof-replacement",
    rating: 5,
    quote:
      "Our Florence home is on a few acres and the roof was past its life. Black Ridge worked around our schedule, did the full tear-off and replacement over a long weekend, repaired some decking that had soft spots, and re-flashed every penetration. The job site was spotless when they left.",
    image: "https://images.unsplash.com/photo-1605146768851-eda79da39897?w=900&q=80",
  },
  {
    id: 32,
    name: "Tyler J.",
    location: "North Austin, TX",
    project: "Gutter & Drainage Repair",
    service: "gutter-drainage-repairs",
    rating: 5,
    quote:
      "Our North Austin house had pooling water against the foundation every storm. Black Ridge re-pitched a section of gutters, replaced two downspouts, and ran underground drainage out to the side yard. First heavy rain after the work, the foundation stayed dry for the first time in five years. Direct, no-BS solution.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 33,
    name: "Brittany M.",
    location: "Briarcliff, TX",
    project: "Exterior Paint & Siding Repairs",
    service: "exterior-painting",
    rating: 5,
    quote:
      "Our Briarcliff lake home needed exterior paint and several siding boards replaced where they'd warped. Black Ridge prepped properly — power-wash, scrape, caulk, prime — before painting, and the finish is clean. They didn't just paint over the bad boards like the previous painter did. Worth doing it right.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 34,
    name: "Carlos R.",
    location: "Jarrell, TX",
    project: "Investor Property Make-Ready",
    service: "investor-property-repairs",
    rating: 5,
    quote:
      "I have a handful of rentals between Jarrell and Georgetown. Black Ridge has done make-readies on three of them now. Their pricing is consistent, the work is solid, and they don't try to upsell me on things the property doesn't need. That's rare in this business.",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=900&q=80",
  },
  {
    id: 35,
    name: "Rebecca S.",
    location: "Coupland, TX",
    project: "Carpentry & Framing Repairs",
    service: "carpentry-framing",
    rating: 5,
    quote:
      "Our older farmhouse outside Coupland had a section of framing in the back wall that had failed from old water damage. Black Ridge cut in new framing without disturbing the rest of the wall, replaced the affected siding, and made it all look original. They treat older homes with respect, not as teardown candidates.",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=900&q=80",
  },
  {
    id: 36,
    name: "Joshua A.",
    location: "Round Rock, TX",
    project: "Kitchen Cabinet Refinish & Counter Replacement",
    service: "kitchen-remodeling",
    rating: 4,
    quote:
      "Solid work overall. Black Ridge refinished our cabinets, installed new quartz counters, and replaced the backsplash in our Round Rock kitchen. The finished kitchen looks great and we'd hire them again. Only reason it's not five stars is the timeline slipped about a week because of a counter delivery delay — they kept us informed, but it still pushed us out. Worth it in the end.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80",
  },
  {
    id: 37,
    name: "Diana V.",
    location: "Pflugerville, TX",
    project: "Bathroom Remodel",
    service: "bathroom-remodeling",
    rating: 4,
    quote:
      "Black Ridge did a full guest bathroom remodel in our Pflugerville home. The initial estimate felt higher than I expected and I almost went with someone else — but once they walked me through everything in scope, I understood why. The execution was clean and the finished bath is exactly what we wanted. Just be ready for a real GC's pricing, not a handyman's.",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=900&q=80",
  },
  {
    id: 38,
    name: "Eric N.",
    location: "Cedar Park, TX",
    project: "Roof Repair After Wind Damage",
    service: "storm-damage-repairs",
    rating: 4,
    quote:
      "After a windstorm took a section of shingles off our Cedar Park home, Black Ridge handled the repair and re-flashed a vent pipe that turned out to be the underlying issue. Repair quality is great. The one thing I'd flag is there was a couple-day lag between when we approved the scope and when work actually started — they were transparent about why (weather and a queued job ahead of us), but it's worth knowing for planning.",
    image: "https://images.unsplash.com/photo-1605146768851-eda79da39897?w=900&q=80",
  },
  {
    id: 39,
    name: "Lauren K.",
    location: "Hutto, TX",
    project: "Drywall & Interior Paint",
    service: "drywall-painting",
    rating: 4,
    quote:
      "Black Ridge patched a long settlement crack and repainted three rooms in our Hutto home. The work looks great. They missed one small drywall blemish on the initial walkthrough, but came back two days later and fixed it without a question. No drama, no charge. I'd use them again.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 40,
    name: "Matthew P.",
    location: "Liberty Hill, TX",
    project: "Home Addition - Bonus Room",
    service: "home-additions",
    rating: 4,
    quote:
      "We added a bonus room above our garage in Liberty Hill. The end result is excellent — properly insulated, tied into the HVAC correctly, and the framing tie-in is invisible from the outside. The project took about two weeks longer than the original schedule because of a window supplier delay outside Black Ridge's control, which they communicated about clearly. Just plan for some buffer if you're working with custom material.",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=900&q=80",
  },
  {
    id: 41,
    name: "Crystal F.",
    location: "Kyle, TX",
    project: "Covered Patio",
    service: "patio-covers",
    rating: 4,
    quote:
      "Our new covered patio in Kyle looks fantastic and was reasonably priced. The construction quality is solid. One small note — the dust cleanup in the adjacent room could have been more thorough on the day they cut into the roofline. They came back the next morning with a vacuum and took care of it, but it would've been nicer if it hadn't been needed. Otherwise, no complaints.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
  },
  {
    id: 42,
    name: "Jason T.",
    location: "Buda, TX",
    project: "Window & Door Replacement",
    service: "window-door-installation",
    rating: 4,
    quote:
      "Black Ridge replaced our five back windows and the rear sliding door at our Buda home. The install quality is excellent and the energy difference is noticeable. One door arrived wrong-sized from the supplier and they had to reorder, which delayed the final day by about a week. They handled it without trying to charge us extra. Would still hire them again.",
    image: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=900&q=80",
  },
  {
    id: 43,
    name: "Samantha O.",
    location: "Bastrop, TX",
    project: "Fence Replacement & Gate Repair",
    service: "fence-gate-work",
    rating: 4,
    quote:
      "Black Ridge tore out and replaced about 160 feet of fence on our Bastrop property and rebuilt the side gate. The work is solid and the gate latches cleanly for the first time in years. They did have to reschedule one workday because of heavy rain, which I understand — they were honest about it instead of pushing through and doing rushed work. Fence still looks great a year later.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 44,
    name: "Paul H.",
    location: "Wimberley, TX",
    project: "Exterior Rot Repair",
    service: "exterior-rot-repair",
    rating: 4,
    quote:
      "Our Wimberley home had more exterior rot than we realized — when Black Ridge opened up the area we'd asked about, they found additional damage behind it. They paused, took photos, walked us through what they found, and gave us a revised scope before continuing. I'd have preferred to know upfront, but honestly there's no way they could have without opening it up. They were honest about it, which is what I care about.",
    image: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
  },
  {
    id: 45,
    name: "Megan L.",
    location: "Dripping Springs, TX",
    project: "Flooring Installation",
    service: "flooring-installation",
    rating: 4,
    quote:
      "Black Ridge installed luxury vinyl plank throughout the main areas of our Dripping Springs home and the floors look fantastic. There was one transition strip near a hallway that needed a second visit to get right — the original install left a small gap. They came back and fixed it without a fuss. Quality work; just took an extra day.",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&q=80",
  },
  {
    id: 46,
    name: "Trevor M.",
    location: "San Marcos, TX",
    project: "HomeCare Essential Maintenance",
    service: "home-maintenance-plans",
    rating: 4,
    quote:
      "We signed up for the HomeCare Essential plan for our San Marcos home. The first couple of visits took a little time to find a rhythm with what mattered to us, but by the third visit they had it down — they show up on schedule, do exactly what was promised, and send a written report with photos. Glad we stuck with it.",
    image: "https://images.unsplash.com/photo-1542621334-a254cf47733d?w=900&q=80",
  },
  {
    id: 47,
    name: "Ashley R.",
    location: "Elgin, TX",
    project: "Garage Conversion to Studio",
    service: "garage-conversions",
    rating: 4,
    quote:
      "We converted our Elgin garage into a studio for my photography business. The construction quality from Black Ridge is great — insulation, electrical, drywall, and finishes are all clean. Looking back, I'd reconsider one design call I made on the entry door placement, but that's on me, not them. They built exactly what I asked for. Happy with how it functions overall.",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=900&q=80",
  },
  {
    id: 48,
    name: "Ronald T.",
    location: "Manor, TX",
    project: "Storm Damage Repair",
    service: "storm-damage-repairs",
    rating: 4,
    quote:
      "Storm took out part of our Manor roof and damaged a section of fascia. Black Ridge handled the repair well — quality of the actual work was high. The initial response was a little slower than I'd hoped given how packed they were after the storm, but once they were on-site the work moved fast. End result is solid and the documentation made the claim straightforward.",
    image: "https://images.unsplash.com/photo-1605146768851-eda79da39897?w=900&q=80",
  },
  {
    id: 49,
    name: "Veronica E.",
    location: "Lakeway, TX",
    project: "Rental Property Turnover",
    service: "turnover-repairs",
    rating: 4,
    quote:
      "Black Ridge handled the turnover on a rental I own in Lakeway. The work itself is high quality and the pricing is fair for the area. There was one bedroom that didn't make it into the initial scope walkthrough — they noticed, added it without disputing it, and didn't try to nickel-and-dime me. Already lined them up for the next turnover.",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=900&q=80",
  },
  {
    id: 50,
    name: "Gregory N.",
    location: "Bee Cave, TX",
    project: "Trim Carpentry & Built-In Shelving",
    service: "trim-carpentry",
    rating: 4,
    quote:
      "Black Ridge built a wall of custom built-in shelving and refreshed all the trim in our Bee Cave living room. The carpentry is genuinely beautiful and we get compliments on it constantly. The final cost came in a little over the initial estimate because of a material upgrade we approved mid-project — they were clear about the change before doing it, no surprise on the invoice, but worth knowing they price upgrades transparently rather than absorbing them.",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&q=80",
  },
];

export const BEFORE_AFTER = [
  {
    id: "b1",
    title: "South Austin Kitchen Refresh",
    location: "South Austin, TX",
    before: "https://images.unsplash.com/photo-1626885930974-4b69aa21bbf9?w=900&q=80",
    after: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80",
    caption: "Full cabinet replacement, quartz counters, new lighting, and pantry wall reconfiguration.",
  },
  {
    id: "b2",
    title: "Round Rock Bathroom Tile Reset",
    location: "Round Rock, TX",
    before: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=900&q=80",
    after: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=900&q=80",
    caption: "Tub-to-shower conversion with custom tile work and improved ventilation.",
  },
  {
    id: "b3",
    title: "Cedar Park Covered Patio",
    location: "Cedar Park, TX",
    before: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=900&q=80",
    after: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
    caption: "New covered patio tied into the existing roofline with electrical for fans and lighting.",
  },
  {
    id: "b4",
    title: "Lakeway Roof Replacement",
    location: "Lakeway, TX",
    before: "https://images.unsplash.com/photo-1503594384566-461fe158e797?w=900&q=80",
    after: "https://images.unsplash.com/photo-1605146768851-eda79da39897?w=900&q=80",
    caption: "Full shingle replacement with damaged decking repair and updated flashing.",
  },
  {
    id: "b5",
    title: "Dripping Springs Hill Country Deck",
    location: "Dripping Springs, TX",
    before: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&q=80",
    after: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
    caption: "Composite deck with proper joist spacing and stainless fasteners designed for Texas weather.",
  },
  {
    id: "b6",
    title: "Bastrop Investor Make-Ready",
    location: "Bastrop, TX",
    before: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=900&q=80",
    after: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=900&q=80",
    caption: "Full turnover scope: drywall repair, paint refresh, flooring, and punch list completion.",
  },
];
